import { useEffect, useState } from "react";
import useLink from "./useLink";
import useScript from "./useScript";

const useLmViewer3D = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useLink("https://developer.api.autodesk.com/modelderivative/v2/viewers/7.*/style.css");
  useScript("https://developer.api.autodesk.com/modelderivative/v2/viewers/7.*/viewer3D.js");

  useEffect(() => {
    setIsLoading(true);
  }, []);

  useEffect(() => {
    if (typeof Autodesk !== "undefined") {
      (async () => {
        try {
          await import("../types/LmViewer3D/Extensions/Viewing.Extension.Scopes/Viewing.Extension.Scopes");
          await import("../types/LmViewer3D/Extensions/Viewing.Extension.TotalCO2/Viewing.Extension.TotalCO2");
          await import("../types/LmViewer3D/Extensions/Viewing.Extension.TextOverlay/Viewing.Extension.TextOverlay");
        } finally {
          setIsLoaded(true);
          setIsLoading(false);
        }
      })();
    }
  }, [window.Autodesk]);

  console.log(`[useLmViewer3D] isLoaded: ${isLoaded}, isLoading: ${isLoading}`);

  return { isLoaded, isLoading };
};

export default useLmViewer3D;
